var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRightArrowCircle = function SvgRightArrowCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "right-arrow-circle_svg__Capa_2",
    viewBox: "0 0 29.96 29.96"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "right-arrow-circle_svg__Capa_1-2",
    d: "M14 .03C6.54.51.51 6.54.03 14c-.58 9.03 6.9 16.5 15.93 15.93 7.46-.48 13.49-6.51 13.97-13.97C30.5 6.93 23.03-.55 14 .03m2.17 8.92 4.95 4.95c.28.28.41.65.39 1.02v.12c.02.37-.11.74-.39 1.02l-4.95 4.95c-.53.53-1.38.53-1.91 0s-.53-1.38 0-1.91l2.89-2.89H6.93a1.23 1.23 0 1 1 0-2.46h10.21l-2.89-2.89c-.53-.53-.53-1.38 0-1.91s1.38-.53 1.91 0Z",
    fill: "currentColor"
  })));
};
export default SvgRightArrowCircle;